import service from "@/services/representation";

const representation = {
  namespaced: true,
  state: {
    index: {},
    representation: {},
  },
  getters: {
    index: (state) => {
      return state.index;
    },
    representation: (state) => {
      return state.representation;
    },
  },
  mutations: {
    index(state, data) {
      state.index = data;
    },
    representation(state, data) {
      state.representation = data;
    },
    to_select(state) {
      let data = state.index;
      let d = [];
      data.forEach((value) => {
        let val = {};
        val.id = value.child_user.id;
        val.name =
          value.child_user.first_name + " " + value.child_user.last_name;
        d.push(val);
      });
      data.to_select = d;
      state.index = data;
    },
  },
  actions: {
    async index({ commit }, props) {
      try {
        let params = props !== undefined && props ? props : {};
        params["with"] = "childUser";
        const data = await service.index(params);
        commit("index", data);
        commit("to_select", data);
        return Promise.resolve();
      } catch (e) {
        console.error(e);
      }
    },
    async representation({ commit }, userId) {
      try {
        const data = await service.representation({ userId: userId });
        commit("representation", data);
        return Promise.resolve();
      } catch (e) {
        console.error(e);
      }
    },
    async changeRepresentation({ dispatch, commit }, { user_id, role_id }) {
      try {
        await service.changeRepresentation(user_id, role_id);
        commit("meeting/clearMeeting", null, { root: true });
        await dispatch("user/fetch", null, { root: true });
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};

export default representation;
